import { ReactElement } from 'react';

import { WaitlistEntry } from '@dreryk/egabinet-waitlist-frontend-api';

import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';
import { FormContextValues } from '@dreryk/react-common';

import { translationKeys } from '../translations';
import { WaitlistForm } from '../form/WaitlistForm';
import { WaitlistFormLoader } from '../form/WaitlistForm.loader';

import { WaitlistEntryUpdateFormBean } from './WaitlistEntryUpdate.types';
import { WaitlistEntryUpdateModalConfirmButton } from './WaitlistEntryUpdateModalConfirmButton';
import { getInitialValues } from './WaitlistEntryUpdate.utils';

type WaitlistEntryUpdateModalProps = {
   onClose: VoidFunction;
   waitlistEntry: WaitlistEntry;
};

export const WaitlistEntryUpdateModal = (props: WaitlistEntryUpdateModalProps): ReactElement => {
   return (
      <Modal testId={'waitlistEntry'} title={translationKeys.editEntry} width={ModalWidth.WIDE}>
         <WaitlistFormLoader>
            {({ practitioners, currentPractitioner }) => (
               <WaitlistForm
                  initialValues={getInitialValues(props.waitlistEntry)}
                  currentPractitioner={currentPractitioner}
                  practitioners={practitioners}
               >
                  {({ handleSubmit, formState }) => (
                     <>
                        <WaitlistEntryUpdateModalConfirmButton
                           handleSubmit={handleSubmit as FormContextValues<WaitlistEntryUpdateFormBean>['handleSubmit']}
                           onSuccess={props.onClose}
                           entryId={props.waitlistEntry.id}
                        />
                        <ModalCancelButton
                           onClick={props.onClose}
                           shouldConfirmExit={{
                              enabled: formState.isDirty,
                              confirmationButtonLabel: translationKeys.leave,
                           }}
                        />
                        <ModalCloseButton
                           onClick={props.onClose}
                           shouldConfirmExit={{
                              enabled: formState.isDirty,
                              confirmationButtonLabel: translationKeys.leave,
                           }}
                        />
                     </>
                  )}
               </WaitlistForm>
            )}
         </WaitlistFormLoader>
      </Modal>
   );
};
